module.exports = __webpack_public_path__ + "media/img/pages/profile/uni basel ger 1-e74fbd45117c7cec84ee5a651717e6f6.jpg";